import React from "react";
import { Button, Card, Form } from "react-bootstrap";
import moment from "moment";

const ProjectWorkflowTab = ({
  // Data
  templates,
  templatesLoading,

  // Handlers
  handleCreateTemplate,
  handleEditTemplate,
  handleDeleteTemplate,
  getFieldDisplayName,
}) => {
  return (
    <div className="project-view-fade-in">
      <div className="project-overview-single-card">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h3 className="project-view-overview-section-title">
            Task Templates
          </h3>
          <Button variant="primary" size="sm" onClick={handleCreateTemplate}>
            Create Template
          </Button>
        </div>

        {/* Task Templates List */}
        <div className="templates-container">
          {templatesLoading ? (
            <div className="text-center py-4">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading templates...</span>
              </div>
            </div>
          ) : templates.length === 0 ? (
            <div className="text-center py-5 text-muted">
              <i className="fas fa-clipboard-list fa-3x mb-3"></i>
              <h5>No Task Templates</h5>
              <p>
                Create your first task template to streamline task creation.
              </p>
              <Button
                variant="outline-primary"
                size="sm"
                onClick={handleCreateTemplate}
              >
                Create Your First Template
              </Button>
            </div>
          ) : (
            <div className="row">
              {templates.map((template) => (
                <div key={template.templateId} className="col-md-6 mb-3">
                  <Card className="template-card h-100">
                    <Card.Body>
                      <div className="d-flex justify-content-between align-items-start mb-2">
                        <Card.Title className="h6 mb-0">
                          {template.templateName}
                        </Card.Title>
                        <div className="template-actions">
                          <Button
                            variant="outline-primary"
                            size="sm"
                            className="me-1"
                            onClick={() => handleEditTemplate(template)}
                            title="Edit Template"
                          >
                            <i className="fas fa-edit"></i>
                          </Button>
                          <Button
                            variant="outline-danger"
                            size="sm"
                            onClick={() =>
                              handleDeleteTemplate(template.templateId)
                            }
                            title="Delete Template"
                          >
                            <i className="fas fa-trash"></i>
                          </Button>
                        </div>
                      </div>

                      {template.templateDescription && (
                        <Card.Text className="text-muted small mb-2">
                          {template.templateDescription}
                        </Card.Text>
                      )}

                      <div className="template-fields">
                        <small className="text-muted">
                          <strong>Fields included:</strong>{" "}
                          {Object.keys(template.includeFields || {}).length}
                        </small>
                        <div className="field-tags mt-1">
                          {Object.keys(template.includeFields || {}).map(
                            (fieldName) => (
                              <span
                                key={fieldName}
                                className="badge bg-light text-dark me-1 mb-1"
                              >
                                {getFieldDisplayName(fieldName)}
                              </span>
                            ),
                          )}
                        </div>
                      </div>

                      <div className="template-footer mt-3 pt-2 border-top">
                        <small className="text-muted">
                          Created:{" "}
                          {moment(template.createdOnDate).format(
                            "MMM DD, YYYY",
                          )}
                        </small>
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProjectWorkflowTab;
